<template>
  <v-card v-if="aquarium.id === 'new'" @click="openNewAquariumModal">
    <v-img :src="getImageUrl(aquarium.image_url)" height="200px" cover></v-img>
    <v-card-title class="pb-1">{{ aquarium.name }}</v-card-title>
    <v-card-subtitle class="pb-2" v-if="aquarium.description">
      <p>{{ aquarium.description }}</p>
    </v-card-subtitle>
  </v-card>
  <v-card v-else :to="'/aquarium/' + aquarium.id">
    <v-img :src="getImageUrl(aquarium.image_url)" height="200px" cover></v-img>
    <v-card-title class="pb-1">{{ aquarium.name }}</v-card-title>
    <v-card-subtitle class="pb-2" v-if="aquarium.description">
      <p>{{ aquarium.description }}</p>
    </v-card-subtitle>
    <!--<v-card-text>
      <div v-if="aquarium.lastLogData">
        <p>Temp: {{ aquarium.lastLogData.temperature }}°F</p>
        <p>pH: {{ aquarium.lastLogData.pH }}</p>
        <p>Salinity: {{ aquarium.lastLogData.salinity }}</p>
      </div>
    </v-card-text>-->
  </v-card>
</template>

<script>
import placeholder1 from '@/assets/placeholder1.png';
import placeholder2 from '@/assets/placeholder2.png';
import placeholder3 from '@/assets/placeholder3.png';
import placeholder4 from '@/assets/placeholder4.png';
import placeholder5 from '@/assets/placeholder5.png';
import { useModalStore } from '@/store';
import { useAuthStore } from '@/store';

const placeholders = {
  1: placeholder1,
  2: placeholder2,
  3: placeholder3,
  4: placeholder4,
  5: placeholder5,
};

export default {
  name: 'AquariumCard',
  props: {
    aquarium: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const modalStore = useModalStore();
    const authStore = useAuthStore();
    return {
      modalStore,
      authStore,
     };
  },
  methods: {
    getImageUrl(imageUrl) {
      if (!imageUrl) {
        return placeholders[1];
      } else if (!isNaN(imageUrl)) {
        return placeholders[parseInt(imageUrl)];
      } else {
        return imageUrl;
      }
    },
    openNewAquariumModal() {
      this.modalStore.openNewAquariumModal({
        mode: 'user',
        verb: 'create',
        prefilledData: { 
          name:'',
          user_id: this.authStore.user.id,
        }
      });
    },
  }
};
</script>